export class SuggestLayer {
  private trackedOnce = false;

  trackShownOnce(onFirstShown: () => void): void {
    if (!this.trackedOnce) {
      this.trackedOnce = true;
      onFirstShown();
    }
  }
}

export const suggestLayer = new SuggestLayer();
